import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import FAQForm from "../../components/FAQForm/FAQForm";

const FaqPage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <FAQForm />
                </div>
            </div>
        </div>
    );
};

export default FaqPage;
